

import { ArrowRight, CheckCircle, Star } from 'lucide-react';
import '../../../../../assets/css/subscreens/customer/dashboard/apphome/topworkers/TopWorkers.css';
import { useWorkerProfileContext } from '../../../../../context/workerprofilecontext/WorkerProfileContext';
import React, { useEffect, useState ,useContext} from 'react';
import AppContext from '../../../../../context/AppContext';
import axios from 'axios';


const getInitials = (name) =>
  name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);

const TopWorkers = () => {
  const {baseUrl, authToken} =useContext(AppContext);

  // fetch workers
  const [workers, setWorkers] = useState([]);
useEffect(() => {
  const viewTopWorkers = () => {
  axios.get(`${baseUrl}/customer/viewtopworkers`, {
  headers: {
    Authorization: `Bearer ${authToken}`
  }
})
    .then((response) => {
      console.log(response.data);
      setWorkers(response.data.workers);
    })
    .catch((error) => {
      console.log(error);
    });
  };

  viewTopWorkers();
}, []);

  // ✅ Context
  const { setSelectedWorkerProfile } = useWorkerProfileContext();

  return (
    <section className="tw-section">

      {/* Header */}
      <div className="tw-header">
        <h2 className="tw-title">Top Workers</h2>
       
      </div>

      {/* Grid */}
      <div className="tw-grid">
        {workers.map(w => (
  <div
    key={w.id}
    className="tw-card"
    onClick={() => {
      setSelectedWorkerProfile(w);
  
    }}
  >
    <div
      className="tw-card__avatar"
      style={{ background: '#dbeafe', color: '#1d4ed8' }}
    >
      <span className="tw-card__initials">
        {w.fullName?.split(' ').map(n => n[0]).join('').slice(0,2).toUpperCase()}
      </span>
    </div>

    <div className="tw-card__info">
      <div className="tw-card__name-row">
        <span className="tw-card__name">{w.fullName}</span>
        <CheckCircle size={15} className="tw-card__verified"/>
      </div>

      <span className="tw-card__profession">{w.selectservice}</span>

      <div className="tw-card__rating">
        <Star size={13} fill="#f59e0b" color="#f59e0b"/>
<span>
  {Number(w.whreviews_avg_workerrating || 0).toFixed(1)}
</span>      </div>
    </div>
  </div>
))}
      </div>

    </section>
  );
};

export default TopWorkers;